// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../../config/styles';

const style = theme => ({
  root: {
    padding: '0 20px',
    flexGrow: 1,
    [theme.breakpoints.down(376)]: {
      padding: 0,
    },
  },
  appBar: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
  },
  tabs: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    borderBottomColor: GlobalStyles.color.COLOR_GREY,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
  },
  tab: {
    textTransform: 'none',
    minWidth: 100,
    '&:hover': {
      textDecoration: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down(750)]: {
      minWidth: 70,
    },
    [theme.breakpoints.down(550)]: {
      minWidth: 50,
    },
    [theme.breakpoints.down(400)]: {
      padding: '6px 10px',
      minWidth: 30,
    },
  },
  Indicator: {
    backgroundColor: GlobalStyles.color.COLOR_YELLOW_SELECT,
  },
  iconHeight: {
    height: 22,
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'center',
  }
});

export default style;
